/**
 * 
 */
var IconGenerator = function () {
    if (isNullOrUndefined(SVG)) {
        throw ("SVG library not found");
    }
    var draw,
    mThis = this,
    alignments = {},
    dimensions = {},
    iconGroups = {},
    shapes = {},
    elementCount = 0,
    parentWidth = 250,
    parentHeight = 250,
    currentCenter = 0,
    drawSizeWidth = 70,
    drawSizeHeight = 70,
    scaleFactor = 100,
    stackErrors = [],
    svgQueue = [],
    bearing = 0,
    cleanSvgRegEx = new RegExp(/xmlns="http:\/\/www\.w3\.org\/2000\/svg"/gm),
    cleanVRegEx = new RegExp(/version="1\.1"/gm),
    cleanXmlRegEx = new RegExp(/\<\?xml version="1\.0"\?\>/gm),
    cleanXmlNS1 = new RegExp(/xmlns:NS1=""/gm),
    cleanXmlNS2 = new RegExp(/xmlns:NS2=""/gm),
    cleanXmlNS3 = new RegExp(/xmlns:NS3=""/gm),
    cleanXmlNS4 = new RegExp(/xmlns:NS4=""/gm),
    cleanXmlNS1Data = new RegExp(/NS1:svgjs:data/gm),
    cleanXmlNS2Data = new RegExp(/NS2:svgjs:data/gm),
    cleanXmlNS3Data = new RegExp(/NS3:svgjs:data/gm),
    cleanXmlNS4Data = new RegExp(/NS4:svgjs:data/gm),
    xmlNSData = " svgjs:data",   
    cleanHtmlRegEx = new RegExp(/\&quot;/gm),
    nsXmlDeclare = ' xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:svgjs="http://svgjs.com/svgjs"',
    isReady = false,
    nested;




    alignments.enums = {
        "CENTER": 0,
        "HORIZONTAL": 1,
        "VERTICAL": 2
    };

    dimensions.enums = {
        "WIDTH": drawSizeWidth,
        "HEIGHT": drawSizeHeight,
        "CX": 0,
        "CY": 0
    };

    iconGroups.enums = {
        "SHAPE": "Shape",
        "IMAGE": "Image"
    };

    shapes.enums = {
        "CIRCLE": "Circle",
        "LINESCROSS": "Lines Cross",
        "LINESDIAGONAL": "Lines Diagonal"
    };

    this.generateMapMarker = function (aSVGString) {
        return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(aSVGString);
    }

    this.cleanSVGTag = function (aSVG, aIsXml) {
        var m,
        mStr,
        lResult,
        lKey,
        mCount = 0;
        if (typeof aSVG == 'string') {
            mStr = aSVG;
        } else {
            mStr = aSVG.toString();
        }
       
        //this will cause performance problems but thats what you get for using IE in 2019
        if (get_browser() == "IE") {            
            ////clean duplicate svg xml tags
            while ((m = cleanSvgRegEx.exec(mStr)) != null) {
                if (m.index == cleanSvgRegEx.lastIndex) {
                    cleanSvgRegEx.lastIndex++;
                }
                m.forEach(function (match, groupIndex) {
                    if (mCount > 0) {
                        if (mCount == 1) {
                            lResult = mStr.substring(0, m.index - 1) + nsXmlDeclare + mStr.substring(m.index + match.length, mStr.length);
                        } else {
                            lResult = mStr.substring(0, m.index - 1) + mStr.substring(m.index + match.length, mStr.length);
                        }                        
                        
                    }
                    mCount++;
                });
            }
            mCount = 0;

            if (isNullOrUndefined(lResult)) {
                lResult = mStr;
            }

            //clean duplicate version xml tags
            while ((m = cleanVRegEx.exec(lResult)) != null) {
                if (m.index == cleanVRegEx.lastIndex) {
                    cleanVRegEx.lastIndex++;
                }
                m.forEach(function (match, groupIndex) {
                    if (mCount > 0) {
                        lResult = lResult.substring(0, m.index - 1) + lResult.substring(m.index + match.length, lResult.length);
                    }
                    mCount++;
                });
            }

            mCount = 0;

            ////clean ns1 xml tags
            while ((m = cleanXmlNS1.exec(lResult)) != null) {
                if (m.index == cleanXmlNS1.lastIndex) {
                    cleanXmlNS1.lastIndex++;
                }
                m.forEach(function (match, groupIndex) {                   
                    lResult = lResult.substring(0, m.index - 1) + lResult.substring(m.index + match.length, lResult.length);                   
                });
            }

            ////clean ns2 xml tags
            while ((m = cleanXmlNS2.exec(lResult)) != null) {
                if (m.index == cleanXmlNS2.lastIndex) {
                    cleanXmlNS2.lastIndex++;
                }
                m.forEach(function (match, groupIndex) {
                    lResult = lResult.substring(0, m.index - 1) + lResult.substring(m.index + match.length, lResult.length);
                });
            }

            ////clean ns3 xml tags
            while ((m = cleanXmlNS3.exec(lResult)) != null) {
                if (m.index == cleanXmlNS3.lastIndex) {
                    cleanXmlNS3.lastIndex++;
                }
                m.forEach(function (match, groupIndex) {
                    lResult = lResult.substring(0, m.index - 1) + lResult.substring(m.index + match.length, lResult.length);
                });
            }

            ////clean ns4 xml tags
            while ((m = cleanXmlNS4.exec(lResult)) != null) {
                if (m.index == cleanXmlNS4.lastIndex) {
                    cleanXmlNS4.lastIndex++;
                }
                m.forEach(function (match, groupIndex) {
                    lResult = lResult.substring(0, m.index - 1) + lResult.substring(m.index + match.length, lResult.length);
                });
            }

            ////clean ns1 data xml tags
            while ((m = cleanXmlNS1Data.exec(lResult)) != null) {
                if (m.index == cleanXmlNS1Data.lastIndex) {
                    cleanXmlNS1Data.lastIndex++;
                }
                m.forEach(function (match, groupIndex) {
                    lResult = lResult.substring(0, m.index - 1) + xmlNSData + lResult.substring(m.index + match.length, lResult.length);
                });
            }

            ////clean ns2 data xml tags
            while ((m = cleanXmlNS2Data.exec(lResult)) != null) {
                if (m.index == cleanXmlNS2Data.lastIndex) {
                    cleanXmlNS2Data.lastIndex++;
                }
                m.forEach(function (match, groupIndex) {
                    lResult = lResult.substring(0, m.index - 1) + xmlNSData + lResult.substring(m.index + match.length, lResult.length);
                });
            }

            ////clean ns3 data xml tags
            while ((m = cleanXmlNS3Data.exec(lResult)) != null) {
                if (m.index == cleanXmlNS3Data.lastIndex) {
                    cleanXmlNS3Data.lastIndex++;
                }
                m.forEach(function (match, groupIndex) {
                    lResult = lResult.substring(0, m.index - 1) + xmlNSData + lResult.substring(m.index + match.length, lResult.length);
                });
            }

            ////clean ns4 data xml tags
            while ((m = cleanXmlNS4Data.exec(lResult)) != null) {
                if (m.index == cleanXmlNS4Data.lastIndex) {
                    cleanXmlNS4Data.lastIndex++;
                }
                m.forEach(function (match, groupIndex) {
                    lResult = lResult.substring(0, m.index - 1) + xmlNSData + lResult.substring(m.index + match.length, lResult.length);
                });
            }
           

            ////clean duplicate xml tag declaration
            while ((m = cleanXmlRegEx.exec(lResult)) != null) {
                if (m.index == cleanXmlRegEx.lastIndex) {
                    cleanXmlRegEx.lastIndex++;
                }
                m.forEach(function (match, groupIndex) {                
                    lResult = lResult.substring(0, m.index - 1) + lResult.substring(m.index + match.length, lResult.length);
                });
            }
        }

        if (isNullOrUndefined(lResult)) {
            lResult = mStr;
        }
        

        if (isNullOrUndefined(aIsXml)) {
            lResult = lResult;
        } else {
            lResult = '<?xml version="1.0"?><root>' + lResult + '</root>';
        }
       
        return lResult;
    };

    this.getSvg = function () {
        return mThis.cleanSVGTag(draw.svg());
    };

    this.addBearingToQueue = function (aBearing) {
        bearing = aBearing;
    };

    this.drawSVG = function () {
        var eCount = svgQueue.length;
        if (eCount == 0) {
            return false;
        }
        var kValue = 0;


        for (var key in svgQueue) {
            if (svgQueue.hasOwnProperty(key)) {
                kValue = parseInt(key) + 1;
                kValue = kValue + "/" + eCount;
                mThis.addSVGValue(svgQueue[key].svg, kValue, svgQueue[key].alignment);
            }
        }
        svgQueue = [];
        return true;
    };

    this.resizeSVG = function (aSVG, aWidth, aHeight) {
        return draw.svg(aSVG).size(aWidth, aHeight);
    };

    this.scale = function (aScaleValue) {
        draw.clear();
        if (aScaleValue == -1) {
            dimensions.enums.WIDTH = drawSizeWidth;
            dimensions.enums.HEIGHT = drawSizeHeight;
            draw = SVG('svgDraw').size(dimensions.enums.WIDTH, dimensions.enums.HEIGHT);
        } else {
            dimensions.enums.WIDTH = dimensions.enums.WIDTH + (dimensions.enums.WIDTH * aScaleValue);
            dimensions.enums.HEIGHT = dimensions.enums.HEIGHT + (dimensions.enums.HEIGHT * aScaleValue);
            draw = SVG('svgDraw').size(dimensions.enums.WIDTH + (dimensions.enums.WIDTH * aScaleValue), dimensions.enums.HEIGHT + (dimensions.enums.HEIGHT * aScaleValue));
        }
        nested = draw.nested();
    };

    this.rotate = function (aSVG, aDegree) {
        aSVG.rotate(aDegree, 0, 0);
    };

    this.rotateThis = function (aDegree) {
        draw.rotate(aDegree, 0, 0)
    };

    this.addSVGToQueue = function (aSVG, aAlignment) {
        svgQueue.push({ 'svg': aSVG, 'alignment': aAlignment });
    };

    this.addText = function (aText, aOptions) {
        var text = draw.text(function (add) {
            add.tspan(aText);
            if (aOptions) {
                add.font(aOptions);
            }
        });

    };

    this.getCenterX = function () {
        return dimensions.enums.CX;
    };

    this.getCenterY = function () {
        return dimensions.enums.CY;
    };

    this.getSVGShape = function (aSVG, aWidth, aHeight) {
        var minHeight = 0;
        if (aWidth > aHeight) {
            minHeight = aWidth;
        } else {
            minHeight = aHeight;
        }


        if (aSVG.Shape == shapes.enums.CIRCLE) {
            var shapeDrawn = draw.circle(minHeight);
            shapeDrawn.center(minHeight / 2, minHeight / 2);
            if (!isNullOrUndefined(aSVG.Move)) {
                shapeDrawn.move(aSVG.Move.cx, aSVG.Move.cy);
            } 
            
            if (aSVG.Stroke != null && aSVG.Stroke != "") {
                shapeDrawn.stroke(aSVG.Stroke);
                shapeDrawn.fill("none");
            }
            return shapeDrawn;
        }

        if (aSVG.Shape == shapes.enums.LINESCROSS) {
            var shapeX = draw.line(0, minHeight, minHeight, 0);
            var shapeY = draw.line(0, minHeight, minHeight, 0);
            shapeX.transform({ rotation: -45 });
            shapeX.stroke({ color: '#f06', width: 10, linecap: 'round' });
            shapeY.transform({ rotation: 45 });
            shapeY.stroke({ color: '#f06', width: 10, linecap: 'round' });
            var shapeGroup = draw.group();
            shapeGroup.add(shapeX);
            shapeGroup.add(shapeY);
            return shapeX;
        }

        if (aSVG.Shape == shapes.enums.LINESDIAGONAL) {
            var shapeX = draw.line(0, minHeight, minHeight, 0);
            var shapeY = draw.line(0, minHeight, minHeight, 0);
            shapeX.stroke({ color: '#f06', width: 10, linecap: 'round' });
            shapeY.transform({ rotation: 90 });
            shapeY.stroke({ color: '#f06', width: 10, linecap: 'round' });
            var shapeGroup = draw.group();
            shapeGroup.add(shapeX);
            shapeGroup.add(shapeY);
            return shapeX;
        }

        return null;
    };

    this.parseIconValue = function (aValue) {
        //raw svg or path
        if (typeof aValue == "svg") {
            return aValue;
        } else if (typeof aValue == "string" && aValue.substring(0, 4) == "<svg") {           
            return draw.svg(aValue);
        } else {
            return nested.path(aValue);
        }
    };

    this.addSVGValue = function (aSVG, aECount, aAlignment) {
        try {
            var shape1;
            //get total element count
            var eCount;
            //total elements
            var dSize;
            //current element
            var nSize;
            var center;
            var mtext;
            var textOptions = {};
           
            if (!isNullOrUndefined(aSVG.IconGroup) && aSVG.IconGroup == iconGroups.enums.SHAPE) {
                shape1 = mThis.getSVGShape(aSVG, aSVG.Width, aSVG.Height);
            } else {
                if (!isNullOrUndefined(aSVG.IconValue)) {
                    shape1 = mThis.parseIconValue(aSVG.IconValue);
                } else {
                    throw "IconValue undefined"
                }
            }


            if (isNullOrUndefined(aECount)) {
                dSize = 1;
                nSize = 1;
            } else {
                eCount = aECount.split("/");
                dSize = eCount.length == 2 ? parseInt(eCount[1]) : 1;
                nSize = parseInt(eCount[0]);
            }

            if (aSVG.Fill != "") {
                shape1.fill(aSVG.Fill);
            }

            if (aSVG.Stroke != "") {
                shape1.stroke(aSVG.Stroke);
            }

            if (!isNullOrUndefined(aSVG.TextOptions)) {
                if (!isNullOrUndefined(aSVG.TextOptions.Text)) {
                    mtext = shape1.text(aSVG.TextOptions.Text);
                }

                if (!isNullOrUndefined(aSVG.TextOptions.Move)) {
                    mtext.move(aSVG.TextOptions.Move.cx, aSVG.TextOptions.Move.cy);
                }
                
                if (!isNullOrUndefined(aSVG.TextOptions.Fill)) {
                    textOptions.fill = aSVG.TextOptions.Fill;                    
                }

                if (!isNullOrUndefined(aSVG.TextOptions.Family)) {
                    textOptions.family = aSVG.TextOptions.Family;
                }

                if (!isNullOrUndefined(aSVG.TextOptions.Size)) {
                    textOptions.size = aSVG.TextOptions.Size;
                }

                if (!isNullOrUndefined(aSVG.TextOptions.Leading)) {
                    textOptions.leading = aSVG.TextOptions.Leading;
                }

                if (!$.isEmptyObject(textOptions)) {
                    mtext.font(textOptions);
                }
            }

            if (isNullOrUndefined(aECount) || aECount == 0) {
                shape1.size(dimensions.enums.WIDTH / dSize, dimensions.enums.HEIGHT / dSize);
                currentCenter = currentCenter + (dimensions.enums.WIDTH / 2);
                shape1.center(currentCenter, currentCenter);
            } else {
                if (aAlignment == alignments.enums.HORIZONTAL) {
                    shape1.size(dimensions.enums.WIDTH / dSize, dimensions.enums.HEIGHT / dSize);
                    center = dimensions.enums.WIDTH / dSize;
                    currentCenter = currentCenter + (center / 2);
                    dimensions.enums.CX = currentCenter;
                    dimensions.enums.CY = dimensions.enums.HEIGHT / 2;
                    shape1.center(currentCenter, dimensions.enums.HEIGHT / 2);
                    currentCenter + currentCenter + (center / 2);
                } else if (aAlignment == alignments.enums.VERTICAL) {
                    shape1.size(dimensions.enums.WIDTH / dSize, dimensions.enums.HEIGHT / dSize);
                    center = dimensions.enums.HEIGHT / dSize;
                    currentCenter = currentCenter + (center / 2);
                    dimensions.enums.CX = dimensions.enums.WIDTH / 2;
                    dimensions.enums.CY = currentCenter;
                    shape1.center(dimensions.enums.WIDTH / 2, currentCenter);
                    currentCenter + currentCenter + (center / 2);
                } else {
                    shape1.size(aSVG.Width, aSVG.Height);
                    center = aSVG.Width / dSize;
                    currentCenter = currentCenter + (center / 2);
                    dimensions.enums.CX = currentCenter;
                    dimensions.enums.CY = currentCenter;
                    //if (bearing != 0) {
                     //shape1.center(aSVG.Width / 2, aSVG.Height /2);
                    //}

                }
            }

            if (nSize == dSize) {
                currentCenter = 0;
                bearing = 0;
            }

        } catch (e) {
            console.log(aSVG);
            console.log(e);
            stackErrors.push(e);
        }
    };

    this.clear = function () {
        svgQueue = [];
        dimensions.enums.WIDTH = drawSizeWidth;
        dimensions.enums.HEIGHT = drawSizeHeight;
        draw.clear();
        nested.clear();
    };

    this.alignments = function () {
        return alignments.enums;
    };

    this.getStackErrors = function () {
        return stackErrors;
    }
    this.clearStackErrors = function () {
        stackErrors = [];
    }

    this.initialize = function () {
        draw = SVG('svgDraw').size(parentWidth, parentHeight);
        nested = draw.nested();
        isReady = true
    }

    this.getStatus = function () {
        return isReady;
    }

    SVG.on(document, 'DOMContentLoaded', function () {
        mThis.initialize();
    });

   
}
/**
 * 
 */
var IconHelper = {
    "getIconIdByName": function (IconName) {
        var lBuilder = new SumoPredicateBuilder();
        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional("IconName", IconName, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

        var lMyIcons = query(mEnrolleesIcon['icons'], lBuilder.RootExpression);
        var IconId = null;
        if (lMyIcons.length > 0) {
            for (lKey in lMyIcons) {
                IconId = lMyIcons[lKey].Id
                break;
            }
        }
        return IconId;
    }
}

if (typeof exports !== 'undefined') {
    module.exports = IconGenerator;
}